import { render, staticRenderFns } from "./nextContact48hours.vue?vue&type=template&id=0ce689b2&"
import script from "./nextContact48hours.vue?vue&type=script&lang=js&"
export * from "./nextContact48hours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports